module.exports = __webpack_public_path__ + "static/media/step-1.0f96e68e.gif";